import React from 'react';
import {FieldEditableProps} from "../../../../proto/render/editable";
import {ADD_USER} from "../../../user/user";

type State = {
    initialPropsValue   : any
    // currentValue        : any
    currentOption       : any
    showPopover         : boolean
}

export default class FieldDropdown_Editable extends React.Component<FieldEditableProps, State> {

    private previousOption: any

    constructor(props:FieldEditableProps) {
        super(props)

        const value = this.props.model[this.props.field.fieldId]

        this.state = {
            initialPropsValue: value, // required to check if currentOption update needed on props changed
            currentOption: props.field._getOption(value),
            showPopover: false,
        }
    }

    static getDerivedStateFromProps(props:any, state:any) {
        const value = props.model[props.field.fieldId]

        if (value !== state.initialPropsValue) {
            return {
                initialPropsValue   : value,
                currentOption       : props.field._getOption(value)
            }
        }

        return null // no changes
    }

    showPopover = () => {if (!this.state.showPopover) this.setState({showPopover: true})}
    hidePopover = () => {if (this.state.showPopover) this.setState({showPopover: false})}

    onOptionClick = (option:any) => {

        this.previousOption = this.state.currentOption;
        if (!option || _.isNil(option.value)) option = null;

        this.setState({
            currentOption: option
        }, () => {
            // if (this.props.onChange) this.props.onChange(_.get(option, 'value', null), this.onCancelChange);
            if (this.props.onChange) this.props.onChange(_.get(option, 'value', null));
            this.hidePopover()
        });
    }

    onCancelChange = () => {
        this.setState({
            currentOption: this.previousOption
        });
    }

    render() {
        const {field} = this.props;

        const classes = Classes(this.props.className, {
            'show-popover' : this.state.showPopover,
        });

        const hasValue = this.state.currentOption && (field.hasOptionWithNullValue || !_.isNil(this.state.currentOption.value))


        // need check value because of none
        if (hasValue) {
            return (
                <field.components.InlineValueNotEmpty className={classes} size={this.props.size} field={this.props.field} option={this.state.currentOption} onClick={this.showPopover}>
                    {this.state.showPopover && <field.components.PopoverMenu {...this.props} parent={this} />}
                </field.components.InlineValueNotEmpty>
            );
        }

        // No value
        return (
            <field.components.InlineValueEmpty className={classes} size={this.props.size} field={this.props.field} onClick={this.showPopover}>
                {this.state.showPopover && <field.components.PopoverMenu {...this.props} parent={this} />}
            </field.components.InlineValueEmpty>
        );
    }
}